export class Tracking {
  id: bigint;
  section: string;
  action_id: number;
  action_name: string;
  user_id: number;
  username: string;
  group_id: number;
  group_name: string;
  enviroment: string;
  company: string;
  permissions: string;
  lang: string;
  table: string;
  field: string;
  type_value: string;
  value: string;
  new_value: string;
  element_id: number;
  element_info: string;
  target_id: number;
  target_info: string;
  date: any;
}
